module.exports = __webpack_public_path__ + "static/media/tag2.0797b1d3.svg";